export default __webpack_public_path__ + "static/media/cohort-users.60cda19b.svg";